var _style, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyMassIndex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "body-mass-index_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".body-mass-index_svg__st0,.body-mass-index_svg__st2{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-miterlimit:10}.body-mass-index_svg__st2{stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "body-mass-index_svg__st0",
    d: "M128.1 136.9H19.9c-4.8 0-8.8-3.9-8.8-8.8V19.9c0-4.8 3.9-8.8 8.8-8.8h108.2c4.8 0 8.8 3.9 8.8 8.8v108.2c0 4.8-4 8.8-8.8 8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "body-mass-index_svg__st0",
    d: "M47.5 11.1c0 14.6 11.8 26.5 26.5 26.5 14.6 0 26.5-11.8 26.5-26.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "body-mass-index_svg__st0",
    d: "M60.3 19.3c2.6 5 7.7 8.4 13.7 8.4s11.2-3.4 13.7-8.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "var(--color-icon-primary)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M36.9 119.5v-68"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "body-mass-index_svg__st2",
    d: "M43.9 117.9H53M43.9 109.6h5M53 101.2h-9.1M43.9 92.9h5M53 84.5h-9.1M43.9 76.1h5M53 67.8h-9.1M43.9 59.4h5M53 51.1h-9.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.9 55.6c-2.4 0-4.5 1.4-5.4 3.4.8-.5 1.8-.7 2.8-.7 3.3 0 6 2.7 6 6 0 .9-.2 1.8-.6 2.6 1.9-1 3.2-3 3.2-5.3 0-3.3-2.6-6-6-6z",
    fill: "var(--color-icon-primary)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "body-mass-index_svg__st2",
    cx: 88.2,
    cy: 61.3,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "body-mass-index_svg__st2",
    d: "M99.4 73.2l10.7 9.9c1.2 1.1 1.4 3 .2 4.2s-3 1.4-4.2.2l-9.4-8.3v8.5c0 4.4.6 8.8 1.8 13l3.5 12.8c.5 2-.5 4.1-2.5 4.7s-4.1-.6-4.7-2.6l-5.3-19.5c-.1-.3-.2-.6-.5-.8-.3-.3-.8-.5-1.2-.5-.8 0-1.6.5-1.9 1.3l-5.3 19.5c-.6 2-2.7 3.2-4.7 2.6s-3-2.7-2.5-4.7l3.6-12.8c1.1-4.2 1.8-8.6 1.8-13v-8.5l-9.4 8.3c-1.2 1.1-3.1 1-4.2-.2s-1-3.1.2-4.2L76 73.2"
  }))));
}
export default SvgBodyMassIndex;